import React from 'react'

import { usePlacesAvailability } from '../list/_load/PlacesAvailabilityLoader'
import { AVAILABILITY_STATUSES } from '../_shared/AvailabilityStatusSelect'
import AvailabilityColumn from './AvailabilityColumn'
import { DndHandler } from '../../../components/dnd/DndHandler'
import { Grid } from '../../../packages/kiti/components/structure/Grid'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'

// Two fixed columns (available/unavailable) rather than the dynamic, screen-config
// driven kanban used for Service Orders (`containers/screens/kanban`) — that engine
// is built around a `Screen`/`ScreenKanbanColumn` entity with user-configurable
// columns, which doesn't fit a status with exactly two fixed values. We do reuse the
// same low-level DnD primitives (`DndHandler`/`Draggable`) that engine is built on.
const AvailabilityKanban = () => {
  const places = usePlacesAvailability()

  return (
    <DndHandler>
      <Scroll scrollX>
        <Grid width="fit-content" align="stretch" gap={1} flex={1}>
          {AVAILABILITY_STATUSES.map(status => (
            <div key={status} style={{ width: '24rem' }}>
              <AvailabilityColumn status={status} items={places.filter(place => place.availabilityStatus === status)} />
            </div>
          ))}
        </Grid>
      </Scroll>
    </DndHandler>
  )
}

export default AvailabilityKanban
